"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var React = require('react');

var useCharLimit = function useCharLimit(_ref) {
  var _ref$hideOnBlur = _ref.hideOnBlur,
      hideOnBlur = _ref$hideOnBlur === void 0 ? true : _ref$hideOnBlur,
      _ref$initialValue = _ref.initialValue,
      initialValue = _ref$initialValue === void 0 ? '' : _ref$initialValue,
      _ref$tooltipAlignment = _ref.tooltipAlignment,
      tooltipAlignment = _ref$tooltipAlignment === void 0 ? 'BOTTOM' : _ref$tooltipAlignment;

  var _React$useState = React.useState(true),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isValid = _React$useState2[0],
      setValid = _React$useState2[1];

  var _React$useState3 = React.useState(initialValue),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      value = _React$useState4[0],
      setValue = _React$useState4[1];

  var _React$useState5 = React.useState(true),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      show = _React$useState6[0],
      setShow = _React$useState6[1];

  var onValidation = function onValidation(v) {
    setValid(v);
  };

  return {
    showCharLimit: show,
    getTextInputProps: function getTextInputProps(_ref2) {
      var _ref2$onChange = _ref2.onChange,
          _onChange = _ref2$onChange === void 0 ? function () {} : _ref2$onChange,
          _ref2$onFocus = _ref2.onFocus,
          _onFocus = _ref2$onFocus === void 0 ? function () {} : _ref2$onFocus,
          _ref2$onBlur = _ref2.onBlur,
          _onBlur = _ref2$onBlur === void 0 ? function () {} : _ref2$onBlur,
          _ref2$invalidMessage = _ref2.invalidMessage,
          invalidMessage = _ref2$invalidMessage === void 0 ? 'Text is too long' : _ref2$invalidMessage;

      return {
        value: value,
        isValid: isValid,
        invalidMessage: invalidMessage,
        onChange: function onChange(v) {
          setValue(v);

          _onChange(v);
        },
        onFocus: function onFocus() {
          if (hideOnBlur) {
            setShow(true);
          }

          _onFocus();
        },
        onBlur: function onBlur() {
          if (hideOnBlur) {
            setShow(false);
          }

          _onBlur();
        },
        tooltipAlignment: tooltipAlignment
      };
    },
    getCharLimitProps: function getCharLimitProps(maxLength) {
      return {
        value: value.length,
        maxValue: maxLength,
        onValidation: onValidation
      };
    }
  };
};

module.exports = useCharLimit;